var _circle, _g, _circle2, _circle3, _circle4, _circle5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTicketing = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 148,
    viewBox: "0 0 233 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 116.5,
    cy: 69.5652,
    r: 69.5652,
    fill: "#EAECF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_782_1511)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.364,
    y: 18.4243,
    width: 191.304,
    height: 71.3044,
    rx: 5.21739,
    transform: "rotate(7.25643 26.364 18.4243)",
    fill: "url(#paint0_linear_782_1511)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.06 102.308C154.584 102.248 154.261 101.704 154.338 101.094L155.745 90.0464C155.823 89.4363 156.272 88.9908 156.748 89.0515C157.225 89.1122 157.548 89.656 157.47 90.2661L156.063 101.313C155.986 101.924 155.537 102.369 155.06 102.308Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.17 85.7373C156.694 85.6766 156.371 85.1329 156.448 84.5227L157.855 73.4754C157.933 72.8653 158.382 72.4198 158.858 72.4805C159.335 72.5412 159.658 73.0849 159.58 73.6951L158.173 84.7424C158.096 85.3525 157.647 85.798 157.17 85.7373Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.28 69.1663C158.804 69.1056 158.481 68.5619 158.558 67.9517L159.965 56.9044C160.043 56.2943 160.492 55.8488 160.968 55.9095C161.445 55.9701 161.768 56.5139 161.69 57.1241L160.283 68.1714C160.206 68.7815 159.757 69.227 159.28 69.1663Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.39 52.5953C160.914 52.5346 160.591 51.9908 160.668 51.3807L162.075 40.3334C162.153 39.7232 162.602 39.2778 163.078 39.3385C163.555 39.3991 163.878 39.9429 163.8 40.553L162.393 51.6004C162.316 52.2105 161.867 52.6559 161.39 52.5953Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.9466,
    y: 29.6541,
    width: 103.478,
    height: 3.47826,
    rx: 1.73913,
    transform: "rotate(7.25643 31.9466 29.6541)",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.7384,
    y: 39.1428,
    width: 69.5652,
    height: 3.47826,
    rx: 1.73913,
    transform: "rotate(7.25643 30.7384 39.1428)",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.4319,
    y: 57.2573,
    width: 47.8261,
    height: 3.47826,
    rx: 1.73913,
    transform: "rotate(7.25643 28.4319 57.2573)",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.4434,
    y: 65.0208,
    width: 47.8261,
    height: 3.47826,
    rx: 1.73913,
    transform: "rotate(7.25643 27.4434 65.0208)",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4548,
    y: 72.7842,
    width: 47.8261,
    height: 3.47826,
    rx: 1.73913,
    transform: "rotate(7.25643 26.4548 72.7842)",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.798,
    y: 46.585,
    width: 34.7826,
    height: 4.34783,
    transform: "rotate(7.25643 171.798 46.585)",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.734,
    y: 78.5012,
    width: 34.7826,
    height: 4.34783,
    transform: "rotate(7.25643 167.734 78.5012)",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.919,
    y: 53.4856,
    width: 34.7826,
    height: 13.0435,
    transform: "rotate(7.25643 170.919 53.4856)",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.855,
    y: 85.4016,
    width: 34.7826,
    height: 13.0435,
    transform: "rotate(7.25643 166.855 85.4016)",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.942,
    y: 69.0125,
    width: 34.7826,
    height: 6.95652,
    transform: "rotate(7.25643 168.942 69.0125)",
    fill: "#D5DDEA"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.478,
    cy: 25.8298,
    r: 3.47826,
    fill: "#EAEEF9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.6739,
    cy: 7.8261,
    r: 4.34783,
    fill: "#EAEEF9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.3261,
    cy: 126.956,
    r: 7.82609,
    fill: "#EAEEF9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 12.1739,
    r: 5.21739,
    fill: "#EAEEF9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_782_1511",
    x: 0.582877,
    y: 15.3516,
    width: 232.328,
    height: 142.726,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.47826,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_782_1511"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.3913
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.4348
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_782_1511"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_782_1511",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_782_1511",
    x1: 1.80406,
    y1: 125.31,
    x2: -7.46189,
    y2: 45.8442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTicketing);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ticketing.f356c45071129dc8ecd248d38973bf1c.svg";